<template>

    <div class="dealer">
        <p>
            Tüm firmalardan müşterinize atamak istediğiniz firmaları teknik servis özelliğini belirterek aktarabilirsiniz. Müşteri 
            firmalarından dilediğiniz firmayı silebilirsiniz. Firmalar yukarıdan aşağıya doğru hiyerarşik bir düzendedirler. 
            Dilerseniz sürükle bırak yöntemi ile bu sıralamayı değiştirebilirsiniz. Yaptığınız işlemlerin gerçekleşe bilmesi için 
            alttaki kaydet butonunu kullanmalısınız aksi halde bütün işlemler geri alınacaktır.
        </p>
        <div class="row">
                <div class="col-6">
                    <h3>Tüm Firmalar </h3>
                    <div class="list-group">
                        <div class="group" v-for="(comp, groupI) in outCompanies" :key="groupI" >
                            <template v-if=" comp.company_info && comp.company_info.length > 0">
                                <strong class="title" > {{comp.Group}} </strong>
                                <div class="element"  v-for="(element, index) in comp.company_info" :key="index">
                                    <div> 
                                        <span> {{element.name}} </span>
                                        <b-form-checkbox
                                            v-model="element.is_technical_service"
                                            name="checkbox-1"
                                            :value="true"
                                            :unchecked-value="false"
                                            >
                                            Teknik Servis
                                        </b-form-checkbox>
                                    </div>
                                    <b-icon @click="addCompany(element, index, groupI)" class="icon" icon="arrow-right-square-fill" variant="primary"/> 
                                </div>
                            </template>
                        </div>
                    
                    </div>
                </div>

                <div class="col-6">
                    <h3>Müşterinin Firmaları</h3>
                    <draggable class="list-group" v-model="hasCompanies">
                        <div v-for="(element, index) in hasCompanies" :key="index" >
                            <template v-if="element.info">
                                <div class="element">
                                    <b-icon @click="removeCompany(element, index)" class="icon" icon="x-square-fill" variant="danger"/> 
                                    <span> 
                                        {{ element.info.name}}
                                    </span>
                                    <div>
                                        <b-badge :variant="getVariant(element.info.comp_type.id)"> {{ element.info.comp_type.name}} </b-badge>
                                        <b-badge v-if="element.info.is_technical_service || element.is_technical_service  " variant="danger"> Teknik Servis </b-badge>
                                        
                                    </div>
                                </div>
                                    <b-icon v-if="index !== hasCompanies.length -1" class="icon" icon="arrow-down-short" variant="default"/> 
                               
                            </template>
                        </div>
                    </draggable>
                </div>
            </div>
       
    </div>
</template>
               
<script>
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import i18n from '@/plugins/i18n';
    import draggable from 'vuedraggable'
    export default {
        name: "Dealers",
        data: function(){
            return{
                variants: ['primary', 'success', 'warning', 'danger', 'info'],
                hasCompanies: this.data ? this.data.has_companies : [],
                outCompanies: this.data ? this.data.out_companies : []
            }
        },
        watch:{
            data(nVal){
                this.hasCompanies = nVal.has_companies
                this.outCompanies = nVal.out_companies
            }
        },
        components:{
            draggable
        },
        props:{
            data: Array || Object,
            modalEvent: Function
        },
        methods:{
            getVariant(data){
                return this.variants[data% 5]
            },
            addCompany(item, i, groupI){
                this.hasCompanies.push({
                    info:{
                        id: item.id,
                        code: item.code,
                        name: item.name,
                        auth_person_name: item.auth_person_name,
                        phone_no: item.phone_no,
                        comp_type: item.comp_type,
                        is_technical_service: item.is_technical_service
                    }
                })
                this.outCompanies[groupI].company_info.splice(i,1)
            },
            removeCompany(item, i){
                let tmpI = this.outCompanies.findIndex(oc => oc.GroupID == item.info.comp_type.id)
                if(this.outCompanies[tmpI].company_info == null)
                    this.outCompanies[tmpI].company_info = [];
                this.outCompanies[tmpI].company_info.push({
                    id: item.info.id,
                    code: item.info.code,
                    name: item.info.name,
                    auth_person_name: item.info.auth_person_name,
                    phone_no: item.info.phone_no,
                    comp_type: item.info.comp_type,
                    is_technical_service: false
                })
                this.hasCompanies.splice(i,1)
            }
        }
      
    }
</script>

<style lang="css" scoped > 
    @import "../styles/dealer.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Customer/components/Dealers.vue